import { requests } from '../../api/services';
import { cancelWithDocument } from '../../api/api.service';
import { LIST_OFFER_URL } from '../../utils/Endpoints';
import { BaseModel } from '../../model/shared/BaseModel';
import { Offer } from '../../model/offer/Offer';
import { OfferItemEvent } from '../../model/offer/OfferItemEvent';
import { IOfferOverview } from '../../model/offer/OfferOverview';

export const OfferService = {
    getOffers: (params: any): Promise<BaseModel<Offer>> => requests.get(`${LIST_OFFER_URL}`, params),
    getAdditionalItems: (id: number | undefined) => requests.get(`${LIST_OFFER_URL}/additional/${id}`),
    getOffer: (id: number): Promise<Offer> => requests.get(`${LIST_OFFER_URL}/${id}`),
    cancelOffer: (id: number, data: { note?: string; file?: File | null }): Promise<Offer> =>
        cancelWithDocument(`${LIST_OFFER_URL}/${id}/cancel`, data),
    getOfferOverview: (id: number): Promise<IOfferOverview> => requests.get(`${LIST_OFFER_URL}/${id}/overview`),
    getOfferEvents: (id: number): Promise<OfferItemEvent[]> => requests.get(`${LIST_OFFER_URL}/${id}/events`),
    editOffer: (id: number, body: Offer): Promise<Offer> => requests.put(`${LIST_OFFER_URL}/${id}`, body),
    addAdditionalItem: (id: number, body: any): Promise<Offer> =>
        requests.put(`${LIST_OFFER_URL}/additional/${id}`, body),
    updatePurchaseOrder: (id: number, purchaseOrderInfluencer: string): Promise<Offer> =>
        requests.put(`${LIST_OFFER_URL}/purchase-order/${id}`, { purchaseOrderInfluencer }),
};
